module.exports = __webpack_public_path__ + "static/media/5C.f0fb508d.svg";